import React, { useReducer } from "react";
import { SetItemReducer, SET_ITEM, DELETE_ITEM } from "reducers/SetItemReducer";
import uuid from "uuid/v1";
import { Embedded } from "components";
import { NotifyProvider } from "context/NotifyContext";

export const isEmbedded =
  ({
    ChildComponent,
    newPlanRedirect,
  }) =>
  () => {
    const [state, dispatch] = useReducer(SetItemReducer, {});

    const createNotification = (notification) => {
      const id = notification.id || uuid();
      if (!state[id])
        dispatch({ type: SET_ITEM, path: id, value: { id, ...notification } });
    };
    const deleteNotification = (id) =>
      dispatch({ type: DELETE_ITEM, path: id });

    return (
      <NotifyProvider value={{ state, createNotification, deleteNotification }}>
        <Embedded newPlanRedirect={newPlanRedirect}>
          {ChildComponent && <ChildComponent /> }
        </Embedded>
      </NotifyProvider>
    );
  };
